module.exports = __webpack_public_path__ + "media/images/greennote 4-3d02bb4d185d36db802b243f3915a9f8.svg";